import { createApiClient, createFileUploader } from '@geefamily/api';
import { env } from '@/lib/env';
import { tokenStore } from '@/lib/token-store';
import { refreshSession } from '@/features/auth/session';

/**
 * The single API client instance for the app.
 *
 * On a 401 it refreshes once and retries the original request, so an access
 * token expiring mid-session is invisible to the user. The client serialises
 * concurrent refreshes, so ten parallel requests hitting 401 together cause one
 * refresh, not ten.
 */
const options = {
  baseUrl: env.apiBaseUrl,
  getAccessToken: () => tokenStore.get(),
  onUnauthorized: async () => {
    const tokens = await refreshSession();
    return tokens?.accessToken ?? null;
  },
};

export const api = createApiClient(options);

/** Multipart uploads, with the same auth and retry behaviour as `api`. */
export const uploadFile = createFileUploader(options);
